import { useTranslation } from 'react-i18next';
import { DashboardContainer } from '@/features/dashboard/containers/dashboard-container';

export default function DashboardPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{t('dashboard.title')}</h1>
        <p className="text-muted-foreground">{t('dashboard.welcome')}</p>
      </div>
      <DashboardContainer />
    </div>
  );
}
